/**
 * Days as the seat usage history counts them: `YYYY-MM-DD` in UTC, the same calendar day for the
 * server and for every viewer. They are kept as strings on purpose, because turning one into a
 * `Date` in the browser's timezone can move it to the day before.
 */

const DAY_MS = 24 * 60 * 60 * 1000;

/** The UTC day an instant falls on. */
export const utcDayOf = (date: Date) => date.toISOString().slice(0, 10);

export const addUtcDays = (day: string, days: number) =>
  utcDayOf(new Date(Date.parse(`${day}T00:00:00.000Z`) + days * DAY_MS));

/** Every day from `from` to `to`, both included. */
export const utcDaysBetween = (from: string, to: string) => {
  const days: string[] = [];

  for (let day = from; day <= to; day = addUtcDays(day, 1)) days.push(day);

  return days;
};

/** A day in the panel's `dd.MM.yyyy`, read as a calendar date so no timezone can shift it. */
export const formatUtcDay = (day: string) => {
  const [year, month, date] = day.split('-').map(Number);

  return new Date(year, month - 1, date).toFormattedString();
};
